import { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Link } from "react-router-dom";
import { HiOutlineUser, HiOutlinePhone, HiOutlineEnvelope, HiOutlineLockClosed, HiOutlineTicket } from "react-icons/hi2";
import logo from "../assets/logo.png";
import { RECAPTCHA_SITE_KEY } from "../config";
import Api from "../service/http";

const Registration = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('accessToken') ? true : false);

  if (isLoggedIn) {
    window.location.href = "/profile";
  }

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    first_name: "",
    phone: "",
    email: "",
    password: "",
    password_confirmation: "",
    referralCode: "",
    agree: true,
  });
  const [captchaToken, setCaptchaToken] = useState(null);
  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  const [error, setError] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!captchaToken) {
      alert("Please verify reCAPTCHA.");
      return;
    }
    setLoading(true);
    const response = await Api.post("/web/register", formData)
    if (response.status === 201) {
      window.location.href = "/signin";
    } else {
      setError(response?.data?.errors);
    }
    setLoading(false);
  };

  return (
    <div className="h-screen flex items-center justify-center bg-[#f8f7fa] dark:bg-[#25293c] p-4 overflow-hidden">
      <div className="w-full max-w-2xl bg-white dark:bg-[#2f3349] rounded-2xl shadow-xl overflow-hidden transition-all duration-300 max-h-[95vh] flex flex-col">
        <div className="p-6 sm:p-8 overflow-y-auto scrollbar-hide">
          <Link to="/" className="flex flex-col items-center mb-6 hover:opacity-80 transition-opacity">
            <div className="w-12 h-12 bg-indigo-50 dark:bg-indigo-500/10 rounded-2xl flex items-center justify-center mb-3 transition-colors">
              <img src={logo} alt="Logo" className="h-8 w-8 object-contain" />
            </div>
            <h1 className="text-xl font-bold text-gray-800 dark:text-white">Adventure starts here 🚀</h1>
          </Link>
          <div className="flex flex-col items-center mb-6 -mt-4">
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">Make your app management easy and fun!</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              {/* Full Name */}
              <div className="space-y-1.5">
                <label className="text-sm font-medium text-gray-700 dark:text-gray-300 ml-1">Full Name</label>
                <div className="relative group">
                  <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-gray-400 group-focus-within:text-indigo-500 transition-colors">
                    <HiOutlineUser size={20} />
                  </div>
                  <input
                    type="text"
                    name="first_name"
                    value={formData?.first_name}
                    onChange={handleChange}
                    placeholder="John Doe"
                    className={`w-full pl-11 pr-4 py-2.5 bg-gray-50 dark:bg-[#25293c] border ${error?.first_name ? 'border-red-500' : 'border-gray-200 dark:border-gray-700'} rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 dark:text-white transition-all`}
                  />
                </div>
                {error?.first_name && <p className="text-xs text-red-500 ml-1">{error.first_name[0]}</p>}
              </div>

              {/* Phone Number */}
              <div className="space-y-1.5">
                <label className="text-sm font-medium text-gray-700 dark:text-gray-300 ml-1">Phone Number</label>
                <div className="relative group">
                  <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-gray-400 group-focus-within:text-indigo-500 transition-colors">
                    <HiOutlinePhone size={20} />
                  </div>
                  <input
                    type="text"
                    name="phone"
                    value={formData?.phone}
                    onChange={handleChange}
                    placeholder="+1 234 567 890"
                    className={`w-full pl-11 pr-4 py-2.5 bg-gray-50 dark:bg-[#25293c] border ${error?.phone ? 'border-red-500' : 'border-gray-200 dark:border-gray-700'} rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 dark:text-white transition-all`}
                  />
                </div>
                {error?.phone && <p className="text-xs text-red-500 ml-1">{error.phone[0]}</p>}
              </div>

              {/* Email */}
              <div className="space-y-1.5">
                <label className="text-sm font-medium text-gray-700 dark:text-gray-300 ml-1">Email</label>
                <div className="relative group">
                  <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-gray-400 group-focus-within:text-indigo-500 transition-colors">
                    <HiOutlineEnvelope size={20} />
                  </div>
                  <input
                    type="email"
                    name="email"
                    value={formData?.email}
                    onChange={handleChange}
                    placeholder="john@example.com"
                    className={`w-full pl-11 pr-4 py-2.5 bg-gray-50 dark:bg-[#25293c] border ${error?.email ? 'border-red-500' : 'border-gray-200 dark:border-gray-700'} rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 dark:text-white transition-all`}
                  />
                </div>
                {error?.email && <p className="text-xs text-red-500 ml-1">{error.email[0]}</p>}
              </div>

              {/* Referral Code */}
              <div className="space-y-1.5">
                <label className="text-sm font-medium text-gray-700 dark:text-gray-300 ml-1">Referral Code (Optional)</label>
                <div className="relative group">
                  <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-gray-400 group-focus-within:text-indigo-500 transition-colors">
                    <HiOutlineTicket size={20} />
                  </div>
                  <input
                    type="text"
                    name="referralCode"
                    value={formData?.referralCode}
                    onChange={handleChange}
                    placeholder="REF123"
                    className="w-full pl-11 pr-4 py-2.5 bg-gray-50 dark:bg-[#25293c] border border-gray-200 dark:border-gray-700 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 dark:text-white transition-all"
                  />
                </div>
              </div>

              {/* Password */}
              <div className="space-y-1.5">
                <label className="text-sm font-medium text-gray-700 dark:text-gray-300 ml-1">Password</label>
                <div className="relative group">
                  <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-gray-400 group-focus-within:text-indigo-500 transition-colors">
                    <HiOutlineLockClosed size={20} />
                  </div>
                  <input
                    type="password"
                    name="password"
                    value={formData?.password}
                    onChange={handleChange}
                    placeholder="••••••••"
                    className={`w-full pl-11 pr-4 py-2.5 bg-gray-50 dark:bg-[#25293c] border ${error?.password ? 'border-red-500' : 'border-gray-200 dark:border-gray-700'} rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 dark:text-white transition-all`}
                  />
                </div>
                {error?.password && <p className="text-xs text-red-500 ml-1">{error.password[0]}</p>}
              </div>

              {/* Confirm Password */}
              <div className="space-y-1.5">
                <label className="text-sm font-medium text-gray-700 dark:text-gray-300 ml-1">Confirm Password</label>
                <div className="relative group">
                  <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-gray-400 group-focus-within:text-indigo-500 transition-colors">
                    <HiOutlineLockClosed size={20} />
                  </div>
                  <input
                    type="password"
                    name="password_confirmation"
                    value={formData?.password_confirmation}
                    onChange={handleChange}
                    placeholder="••••••••"
                    className={`w-full pl-11 pr-4 py-2.5 bg-gray-50 dark:bg-[#25293c] border ${error?.password_confirmation ? 'border-red-500' : 'border-gray-200 dark:border-gray-700'} rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 dark:text-white transition-all`}
                  />
                </div>
                {error?.password_confirmation && <p className="text-xs text-red-500 ml-1">{error.password_confirmation[0]}</p>}
              </div>
            </div>

            <div className="flex items-start px-1 pt-2">
              <label className="flex items-start cursor-pointer group">
                <input
                  type="checkbox"
                  id="terms"
                  name="agree"
                  checked={formData?.agree}
                  onChange={handleChange}
                  className="mt-1 w-4 h-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 dark:bg-[#25293c] dark:border-gray-700 transition-all cursor-pointer"
                />
                <span className="ml-2.5 text-sm text-gray-600 dark:text-gray-400 group-hover:text-gray-800 dark:group-hover:text-gray-200 transition-colors">
                  I agree to <Link to="#" className="text-indigo-600 dark:text-indigo-400 hover:underline font-medium">privacy policy & terms</Link>
                </span>
              </label>
            </div>

            {/* reCAPTCHA */}
            <div className="flex justify-center py-2 overflow-hidden scale-90 sm:scale-100 origin-center">
              <ReCAPTCHA
                sitekey={RECAPTCHA_SITE_KEY}
                onChange={handleCaptchaChange}
                theme="light"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-indigo-600 hover:bg-indigo-700 active:bg-indigo-800 text-white py-3 rounded-xl font-bold shadow-lg shadow-indigo-200 dark:shadow-none transition-all duration-200 disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              {loading ? (
                <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
              ) : (
                "Sign Up"
              )}
            </button>

            <p className="text-center text-sm text-gray-500 dark:text-gray-400 mt-6">
              Already have an account?{" "}
              <Link to="/signin" className="font-bold text-indigo-600 dark:text-indigo-400 hover:underline">
                Sign in instead
              </Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Registration;
